module.exports = __webpack_public_path__ + "static/media/doctor.fe763512.png";